import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgDocument = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 20 21'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <mask
      id='document_svg__a'
      width={14}
      height={17}
      x={3}
      y={2}
      maskUnits='userSpaceOnUse'
      style={{
        maskType: 'alpha',
      }}
    >
      <path
        fill='#000'
        d='M3.75 16.333V4.667a2.5 2.5 0 0 1 2.5-2.5h3.06a2.5 2.5 0 0 1 1.768.732l4.44 4.44a2.5 2.5 0 0 1 .732 1.768v7.226a2.5 2.5 0 0 1-2.5 2.5h-7.5a2.5 2.5 0 0 1-2.5-2.5'
        opacity={0.5}
      />
      <path
        fill='#000'
        d='M10.208 2.336a2.5 2.5 0 0 1 .87.563l4.44 4.44c.249.25.437.547.562.87h-4.83a1.04 1.04 0 0 1-1.042-1.042z'
      />
    </mask>
    <g mask='url(#document_svg__a)'>
      <path fill='{props.color} #000' fillOpacity={0.8} d='M0 .5h20v20H0z' />
    </g>
  </svg>
)
const ForwardRef = forwardRef(SvgDocument)
export default ForwardRef
